import React, { useState } from "react";
import {
  Alert,
  Button,
  Col,
  FormGroup,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Row,
} from "reactstrap";
import DatePicker, { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import "react-datepicker/dist/react-datepicker.css";
import ModalHeader from "@dhn/components/molecules/modal-header";

registerLocale("es", es);

export default function ModalDateOfBirth({
  isOpen,
  loading,
  patientName,
  onSave,
}) {
  const [dateOfBirth, setDateOfBirth] = useState(null);

  const handleSave = () => {
    if (!dateOfBirth) return;
    const formatted = dateOfBirth.toISOString().split("T")[0];
    onSave(formatted);
  };

  return (
    <Modal isOpen={isOpen} centered backdrop="static" keyboard={false}>
      <ModalHeader
        iconClass="fa-birthday-cake"
        description="Fecha de nacimiento requerida"
        subtitle="Complete la fecha de nacimiento del paciente para continuar."
      />

      <ModalBody>
        <Row form>
          <Col>
            <Alert color="warning">
              El paciente <strong>{patientName || ""}</strong> no tiene fecha
              de nacimiento registrada. Este dato es obligatorio para continuar
              con la cita.
            </Alert>
          </Col>
        </Row>
        <Row form>
          <Col>
            <FormGroup className="mb-0">
              <Label for="dateOfBirth">Fecha de Nacimiento:</Label>
              <DatePicker
                id="dateOfBirth"
                selected={dateOfBirth}
                onChange={(date) => setDateOfBirth(date)}
                dateFormat="dd/MM/yyyy"
                locale="es"
                maxDate={new Date()}
                showYearDropdown
                showMonthDropdown
                dropdownMode="select"
                placeholderText="DD/MM/AAAA"
                className="form-control"
                wrapperClassName="d-block"
                autoComplete="off"
              />
            </FormGroup>
          </Col>
        </Row>
      </ModalBody>

      <ModalFooter>
        <Button
          color="success" className="btn-color-success"
          disabled={!dateOfBirth || loading}
          onClick={handleSave}
        >
          <i
            className={`fa ${loading ? "fa-spinner fa-spin" : "fa-save"}`}
            aria-hidden="true"
          ></i>
          {loading ? " Guardando..." : " Guardar"}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
